module.exports = __webpack_public_path__ + "hotelKeyLogo.png?a2e29d1bc741a3fa5d7d5f27a005d3de";